// src/store/slices/authSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, User } from './types';

const initialState: AuthState = {
  user: JSON.parse(localStorage.getItem('autopath_user') || 'null'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<User>) {
      state.user = action.payload;
      localStorage.setItem('autopath_user', JSON.stringify(action.payload));
    },

    logout(state) {
      state.user = null;

      // Clear all data from localStorage
      localStorage.clear()

      // Clear sessionStorage items
      sessionStorage.removeItem('pkce_code_verifier');
      sessionStorage.removeItem('tenant');
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;